/**
 * @generated SignedSource<<ce776db6032c66f4cd97bcd72a156e5d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRunnerPhase = "BINDING_VOLUME" | "PENDING" | "PREPARING_WORKSPACE" | "READY" | "SCHEDULING_POD" | "STARTING_POD";
export type WorkspaceViewViewerQuery$variables = {
  id: string;
};
export type WorkspaceViewViewerQuery$data = {
  readonly node: {
    readonly viewer?: {
      readonly phase: WorkspaceRunnerPhase;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspacePhaseProgressFragment" | "WorkspaceViewerFragment">;
    } | null | undefined;
  };
};
export type WorkspaceViewViewerQuery = {
  response: WorkspaceViewViewerQuery$data;
  variables: WorkspaceViewViewerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WorkspaceRunner",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v2/*:: as any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "WorkspaceViewerFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "WorkspacePhaseProgressFragment"
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WorkspaceRunner",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceViewViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v3/*:: as any*/),
            "type": "Workspace",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v3/*:: as any*/),
            "type": "WorkspaceVersion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceViewViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*:: as any*/),
            "type": "Workspace",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*:: as any*/),
            "type": "WorkspaceVersion",
            "abstractKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "43f1f39a216006635ee734fd46d1c96c",
    "id": null,
    "metadata": {},
    "name": "WorkspaceViewViewerQuery",
    "operationKind": "query",
    "text": "query WorkspaceViewViewerQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Workspace {\n      viewer {\n        phase\n        ...WorkspaceViewerFragment\n        ...WorkspacePhaseProgressFragment\n        id\n      }\n    }\n    ... on WorkspaceVersion {\n      viewer {\n        phase\n        ...WorkspaceViewerFragment\n        ...WorkspacePhaseProgressFragment\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment WorkspacePhaseProgressFragment on WorkspaceRunner {\n  phase\n}\n\nfragment WorkspaceViewerFragment on WorkspaceRunner {\n  id\n  phase\n  url\n  ...WorkspacePhaseProgressFragment\n}\n"
  }
};
})();

(node as any).hash = "d04eebbc766356a638c3300237320908";

export default node;
